import { useEffect } from 'react';
import { useCompareContext } from '@/context/compare';

export default onClosePopup => {
  const [{ productsCount, compareOpen }] = useCompareContext();

  useEffect(() => {
    if (productsCount === 1 && compareOpen) {
      onClosePopup();
    }
  }, [productsCount, compareOpen]);
};
